(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Click: navigate to swatch product */
    document.addEventListener('click', function (e) {
      var swatch = e.target.closest('.pc__swatch[data-href]');
      if (swatch) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = swatch.getAttribute('data-href');
      }
    });

    /* Hover individual swatch: swap image */
    document.addEventListener('mouseenter', function (e) {
      var swatch = e.target.closest('.pc__swatch[data-swatch-src]');
      if (!swatch) return;

      var card = swatch.closest('.pc');
      if (!card) return;

      var primary = card.querySelector('.pc__img--primary');
      if (!primary) return;

      if (!card._pcOrigSrc) {
        card._pcOrigSrc = primary.src;
        card._pcOrigSrcset = primary.srcset || '';
      }

      primary.src = swatch.getAttribute('data-swatch-src');
      primary.srcset = swatch.getAttribute('data-swatch-srcset');

      var hoverImg = card.querySelector('.pc__img--hover');
      if (hoverImg) hoverImg.style.display = 'none';
    }, true);

    /* Restore only when mouse leaves the entire swatches container */
    document.addEventListener('mouseleave', function (e) {
      var row = e.target.closest('.pc__swatches');
      if (!row) return;

      /* If the mouse is moving to another element inside the same row, do nothing */
      var next = e.relatedTarget;
      if (next && row.contains(next)) return;

      var card = row.closest('.pc');
      if (!card || !card._pcOrigSrc) return;

      var primary = card.querySelector('.pc__img--primary');
      if (!primary) return;

      primary.src = card._pcOrigSrc;
      primary.srcset = card._pcOrigSrcset;

      var hoverImg = card.querySelector('.pc__img--hover');
      if (hoverImg) hoverImg.style.display = '';
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
